@if (on === 'form' && control.field.condensed) {
    <div class="condensed">
        <div class="condensed-label">{{control.field.label}}</div>
        <div class="condensed-value">
            <span [attr.data-field]="control.field.name">{{control.field.getDisplayValueFromId(control.value)}}</span>
            <div class="condensed-hint">
                @if (control.field.hint) {
                    <mat-icon [matTooltip]="control.field.hint" matTooltipPosition="above">help</mat-icon>
                }
            </div>
        </div>
    </div>
} @else if (on === 'form' && !control?.field.picklist.asRadio) {
  <mat-form-field
    style="height: 74px;">
    @if (control.field.hint) {
      <mat-icon matSuffix color="primary" [matTooltip]="control.field.hint">info</mat-icon>
    }
    <mat-label>{{control.field.label}}</mat-label>
    @if (!control.field.readonly) {
      <div>
        <mat-select [attr.data-field]="control.field.name" [formControl]="control" style="width:calc(100% - 9px)"
          (selectionChange)="itemChanges($event)" [compareWith]="matchById">
          @for (item of this.control.field.picklist.items; track $index) {
            <mat-option id='{{control.field.name}}-{{control.field.picklist.optionDisplayValue(item)}}'
              [value]="this.control.field.picklist.optionValue(item)"
              >
              {{control.field.picklist.optionDisplayValue(item)}}
            </mat-option>
          }
        </mat-select>
        @if (this.control.field.picklist.detailView && this.control.value) {
          <button class="link-styled-button" style="float:right"
            matTooltip="Click to see details" (click)="viewDetails($event)">
            <mat-icon color="primary" style="margin-right: -15px">chevron_right</mat-icon>
          </button>
        }
      </div>
    } @else {
        @if (control.field.picklist.selfPopulate) {
            <!-- Self poppers values come late, so labels do not display correctly without using ngModel-->
            <input matInput [ngModel]="this.control.field.getDisplayValueFromId(control.value)" [disabled]="control.field.disable"
                [attr.data-field]="control.field.name"
                style="padding-top: 3px; padding-bottom: 3px" [matTooltip]="control.field.hint" readonly>
        } @else {
            <input matInput [value]="this.control.field.getDisplayValueFromId(control.value)" [disabled]="control.field.disable"
                [attr.data-field]="control.field.name"
                style="padding-top: 3px; padding-bottom: 3px" [matTooltip]="control.field.hint" readonly>            
        }
    }

    <mat-error style="margin-top: -5px">
      <app-form-error [control]="control"></app-form-error>
    </mat-error>
  </mat-form-field>
}
<!-- div style="font-size: 75%; margin-top: -18px; padding-left: 18px; margin-bottom: 4px; font-weight: 300; min-height: 1.2em;"
*ngIf="on === 'form'">
<span *ngIf="on === 'form' && !control.field.readonly && control.field.hint">{{control.field.hint}}</span>
</div -->
@if (on === 'grid' && !control.field.readonly) {
  <mat-select style="font-size: 14px"
    [ngClass]="{'error': control.invalid && control.touched}"
    [matTooltip]="control.getErrorMessage()"
    [attr.data-field]="control.field.name"
    [attr.data-field-name]="control.field.name"
    [formControl]="control" [compareWith]="matchById" (selectionChange)="itemChanges($event)">
    @for (item of this.control.field.picklist.items; track item) {
      <mat-option [value]="this.control.field.picklist.optionValue(item)"
        >
      {{control.field.picklist.optionDisplayValue(item)}}</mat-option>
    }
  </mat-select>
}
@if (on === 'grid' && control.field.readonly) {
  <span>{{control.field.getDisplayValueFromId(control.value)}}</span>
}
<!-- input *ngIf="on === 'grid' && control.field.readonly" matInput
[value]="control.value ? this.control.field.getDisplayValueFromId(control.value) : ''"
[matTooltip]="control.field.hint" readonly -->
